module.exports = __webpack_public_path__ + "static/lorena-7b126fea32c09a36a69df257f8b06cf8.jpeg";